import React from 'react';
import styled from 'styled-components/native';
import { Platform } from 'react-native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const StyledContainer = styled.View`
  flex-direction: row;
`;
const StyledImage = styled.Image`
  width: 40px;
  height: 40px;
`;
const StyledColumn = styled.View`
  flex-direction: column;
`;
const Types = ['default', 'favorite'];
export default function LogoCard(props) {
  const descriptionColor = props.type === 'favorite' ? Colors.gray300 : Colors.gray400;
  const type = Types.includes(props.type) ? props.type : LogoCard.defaultProps.type;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    style: type === 'favorite' && styles.paddedContainer
  }, Platform.select({
    web: /*#__PURE__*/React.createElement(StyledImage, {
      source: {
        uri: props.imgSrc
      }
    }),
    default: /*#__PURE__*/React.createElement(StyledImage, {
      source: props.imgSrc
    })
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(StyledColumn, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray600
  }, props.name), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: descriptionColor
  }, props.description)));
}
LogoCard.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  imgSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LogoCard.defaultProps = {
  name: '',
  description: '',
  type: 'default',
  imgSrc: ''
};
const styles = {
  paddedContainer: {
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: 10,
    backgroundColor: Colors.white,
    padding: 16
  }
};
//# sourceMappingURL=logo.js.map